import { IEscrowBankAccountResponse } from '../../../accounting/response/IEscrowBankAccountResponse';
import { IAchPullDepositData } from '../IAchPullDepositData';
import { eDepositCategory } from '../eDepositCategory';
import { eAchPullPayerType } from '../eAchPullPayerType';
import { IAchAccountResponse } from '../../../accounting/response/IEscrowExpectedAchPullDepositResponse';

export interface IAchPullDepositResponse {
  id: string;
  ownerId?: string;
  amountCents: number;
  wellsFargoTransactionNumber: string;
  memo: string;
  // val matches: List<MatchAchPullDepositResponse>?,?
  category?: eDepositCategory;
  payerType: eAchPullPayerType;
  enqueuedForDisbursementAt?: string;
  processingForDisbursementStartedAt?: string;
  processingForDisbursementCompletedAt?: string;
  emdAchReportId?: string;
  achAccount?: IAchAccountResponse;
  bankAccount: IEscrowBankAccountResponse;
  createdAt: string;
  updatedAt?: string;
}

export const convertIAchPullDepositResponseToIAchPullDepositData = ({
  id,
  ownerId,
  amountCents,
  wellsFargoTransactionNumber,
  memo,
  category,
  payerType,
  enqueuedForDisbursementAt,
  processingForDisbursementStartedAt,
  processingForDisbursementCompletedAt,
  emdAchReportId,
  achAccount,
  bankAccount,
  createdAt,
  updatedAt,
}: IAchPullDepositResponse): IAchPullDepositData => ({
  id,
  amountCents,
  payerType,
  // label?
  memo,
  account: achAccount,
  bankAccount,
  wellsFargoTransactionNumber,
  enqueuedForDisbursementAt,
  // TODO: these dates are most likely wrong
  sentAt: enqueuedForDisbursementAt,
  completedAtDate: processingForDisbursementCompletedAt,
  disbursedAt: processingForDisbursementStartedAt,
  category,
  ownerId,
  createdAt,
  updatedAt,
});
